/**
 * 认证工具模块
 * 封装 Token 操作和登录状态检测
 */

const TOKEN_KEY = 'token_xzt_edu'

/**
 * 从 Cookie 中获取值
 * @param {string} cName - Cookie 名称
 * @returns {string} Cookie 值
 */
function getCookie (cName) {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) cEnd = document.cookie.length
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}

/**
 * 设置 Cookie
 * @param {string} name - Cookie 名称
 * @param {string} value - Cookie 值
 * @param {number} days - 过期天数
 */
function setCookie (name, value, days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toGMTString()
  }
  document.cookie = name + '=' + escape(value) + expires + '; path=/'
}

/**
 * 删除 Cookie
 * @param {string} name - Cookie 名称
 */
function deleteCookie (name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
}

const auth = {
  /**
   * 检测用户是否已登录
   * @returns {boolean}
   */
  isLoggedIn () {
    return !!this.getToken()
  },

  /**
   * 获取当前 Token
   * 优先从 Cookie 获取，其次从 localStorage 获取
   * @returns {string|null}
   */
  getToken () {
    const tokenFromCookie = getCookie(TOKEN_KEY)
    if (tokenFromCookie) {
      return tokenFromCookie
    }
    return localStorage.getItem(TOKEN_KEY)
  },

  /**
   * 保存 Token 到 Cookie 和 localStorage
   * @param {string} token - Token 值
   * @param {number} days - Cookie 过期天数，默认 1 天（24小时）
   */
  setToken (token, days = 1) {
    setCookie(TOKEN_KEY, token, days)
    // localStorage.setItem(TOKEN_KEY, token)
  },

  /**
   * 清除 Token（退出登录时调用）
   */
  clearToken () {
    deleteCookie(TOKEN_KEY)
    localStorage.removeItem(TOKEN_KEY)
  },

  /**
   * 获取 Cookie 工具方法（供外部使用）
   */
  getCookie,
  setCookie,
  deleteCookie
}

export default auth



// WEBPACK FOOTER //
// ./src/utils/auth.js